import { BundleDiscountSystem } from "src/types/bundle-discounts/BundleDiscountSystem";
import { BundleDiscountType } from "src/types/bundle-discounts/BundleDiscountType";

export const egyptBundleDiscountSystems: BundleDiscountSystem[] = [
  // Standard percentage bundles
  {
    type: BundleDiscountType.bundle3,
    minimumItems: 3,
    range: ["3"],
    priority: 1,
    active: false, // Easily activate/deactivate
    description: "15% off when buying 3 or more items",
    discountsPerItem: {
      // ipanema
      C01BM: { amount: 15, type: "percentage" },
      C01CM: { amount: 15, type: "percentage" },
      C01PM: { amount: 15, type: "percentage" },
      C01VM: { amount: 15, type: "percentage" },
      C01DM: { amount: 15, type: "percentage" },
      // ipanema+
      C01BF: { amount: 15, type: "percentage" },
      C01CF: { amount: 15, type: "percentage" },
      C01PF: { amount: 15, type: "percentage" },
      C01VF: { amount: 15, type: "percentage" },
      C01DF: { amount: 15, type: "percentage" },
      // alexandria
      C03BM: { amount: 15, type: "percentage" },
      C03BF: { amount: 15, type: "percentage" },
      // bahia
      C02BM: { amount: 15, type: "percentage" },
      C02BF: { amount: 15, type: "percentage" },
      // havena
      C04BF: { amount: 15, type: "percentage" },
      C04CF: { amount: 15, type: "percentage" },
      C04PF: { amount: 15, type: "percentage" },
      C04VF: { amount: 15, type: "percentage" },
      C04DF: { amount: 15, type: "percentage" },
      // copacabana
      C05BM: { amount: 15, type: "percentage" },
      // wakiki
      C06BM: { amount: 15, type: "percentage" },
      C06CM: { amount: 15, type: "percentage" },
      // wash bag
      C08BM: { amount: 15, type: "percentage" },
      // travel bag
      C09BM: { amount: 15, type: "percentage" },
    },
  },

  // Buy X Get Y Free bundles
  {
    type: BundleDiscountType.BuyGet,
    minimumItems: 4,
    label: "1 Free",
    range: ["4+"],
    priority: 2,
    active: false,
    description: "Buy 4 Get 1 Free - Free item on every 4 items purchased",
    discountsPerItem: {
      C01BM: { amount: 100, type: "percentage" },
      C01CM: { amount: 100, type: "percentage" },
      C01PM: { amount: 100, type: "percentage" },
      C01VM: { amount: 100, type: "percentage" },
      C01DM: { amount: 100, type: "percentage" },
      C01BF: { amount: 100, type: "percentage" },
      C01CF: { amount: 100, type: "percentage" },
      C01PF: { amount: 100, type: "percentage" },
      C01VF: { amount: 100, type: "percentage" },
      C01DF: { amount: 100, type: "percentage" },
      C03BM: { amount: 100, type: "percentage" },
      C03BF: { amount: 100, type: "percentage" },
      C02BM: { amount: 100, type: "percentage" },
      C02BF: { amount: 100, type: "percentage" },
      C04BF: { amount: 100, type: "percentage" },
      C04CF: { amount: 100, type: "percentage" },
      C04PF: { amount: 100, type: "percentage" },
      C04VF: { amount: 100, type: "percentage" },
      C04DF: { amount: 100, type: "percentage" },
      C05BM: { amount: 100, type: "percentage" },
      C06BM: { amount: 100, type: "percentage" },
      C06CM: { amount: 100, type: "percentage" },
      C08BM: { amount: 100, type: "percentage" },
      C09BM: { amount: 100, type: "percentage" },
    },
  },

  // 50% off 3rd item bundle
  {
    type: BundleDiscountType.NthItemDiscount,
    minimumItems: 3,
    label: "50% on 3rd",
    range: ["3"],
    priority: 3,
    active: false,
    description: "Buy 3 and get 50% off the 3rd item",
    discountOnNthItem: 3,
    discountsPerItem: {
      C01BM: { amount: 50, type: "percentage" },
      C01CM: { amount: 50, type: "percentage" },
      C01PM: { amount: 50, type: "percentage" },
      C01VM: { amount: 50, type: "percentage" },
      C01DM: { amount: 50, type: "percentage" },
      C01BF: { amount: 50, type: "percentage" },
      C01CF: { amount: 50, type: "percentage" },
      C01PF: { amount: 50, type: "percentage" },
      C01VF: { amount: 50, type: "percentage" },
      C01DF: { amount: 50, type: "percentage" },
      C03BM: { amount: 50, type: "percentage" },
      C03BF: { amount: 50, type: "percentage" },
      C02BM: { amount: 50, type: "percentage" },
      C02BF: { amount: 50, type: "percentage" },
      C04BF: { amount: 50, type: "percentage" },
      C04CF: { amount: 50, type: "percentage" },
      C04PF: { amount: 50, type: "percentage" },
      C04VF: { amount: 50, type: "percentage" },
      C04DF: { amount: 50, type: "percentage" },
      C05BM: { amount: 50, type: "percentage" },
      C06BM: { amount: 50, type: "percentage" },
      C06CM: { amount: 50, type: "percentage" },
      C08BM: { amount: 50, type: "percentage" },
      C09BM: { amount: 50, type: "percentage" },
    },
  },

  // Advanced Buy X Get Y bundles
  {
    type: BundleDiscountType.BuyXGetY,
    minimumItems: 4,
    buyQuantity: 4,
    getQuantity: 1,
    label: "1 Free",
    range: ["4+"],
    priority: 5,
    active: true,
    description: "Buy 4 pay 3 - 1 free item for every 4 purchased",
    arabicDescription: "اشتري 4 وادفعي 3 فقط - قطعة مجانية عند شراء 4 قطع",
    discountsPerItem: {
      C01BM: { amount: 100, type: "percentage" },
      C01CM: { amount: 100, type: "percentage" },
      C01PM: { amount: 100, type: "percentage" },
      C01VM: { amount: 100, type: "percentage" },
      C01DM: { amount: 100, type: "percentage" },
      C01BF: { amount: 100, type: "percentage" },
      C01CF: { amount: 100, type: "percentage" },
      C01PF: { amount: 100, type: "percentage" },
      C01VF: { amount: 100, type: "percentage" },
      C01DF: { amount: 100, type: "percentage" },
      C03BM: { amount: 100, type: "percentage" },
      C03BF: { amount: 100, type: "percentage" },
      C02BM: { amount: 100, type: "percentage" },
      C02BF: { amount: 100, type: "percentage" },
      C04BF: { amount: 100, type: "percentage" },
      C04CF: { amount: 100, type: "percentage" },
      C04PF: { amount: 100, type: "percentage" },
      C04VF: { amount: 100, type: "percentage" },
      C04DF: { amount: 100, type: "percentage" },
      C05BM: { amount: 100, type: "percentage" },
      C06BM: { amount: 100, type: "percentage" },
      C06CM: { amount: 100, type: "percentage" },
      C08BM: { amount: 100, type: "percentage" },
      C09BM: { amount: 100, type: "percentage" },
    },
  },

  // Currently active: Buy 6 Get 2 Free
  {
    type: BundleDiscountType.BuyXGetY,
    minimumItems: 6,
    label: "2 Free",
    getQuantity: 2,
    range: ["6+"],
    priority: 10, // Higher priority
    active: true, // This is the currently active bundle
    description: "Buy 6 and pay 4 - 2 free items on every 6 items purchased",
    arabicDescription: "اشتري 6 وادفعي ثمن 4 فقط - قطعتين مجانيتين عند شراء 6 قطع",
    discountsPerItem: {
      C01BM: { amount: 100, type: "percentage" },
      C01CM: { amount: 100, type: "percentage" },
      C01PM: { amount: 100, type: "percentage" },
      C01VM: { amount: 100, type: "percentage" },
      C01DM: { amount: 100, type: "percentage" },
      C01BF: { amount: 100, type: "percentage" },
      C01CF: { amount: 100, type: "percentage" },
      C01PF: { amount: 100, type: "percentage" },
      C01VF: { amount: 100, type: "percentage" },
      C01DF: { amount: 100, type: "percentage" },
      C03BM: { amount: 100, type: "percentage" },
      C03BF: { amount: 100, type: "percentage" },
      C02BM: { amount: 100, type: "percentage" },
      C02BF: { amount: 100, type: "percentage" },
      C04BF: { amount: 100, type: "percentage" },
      C04CF: { amount: 100, type: "percentage" },
      C04PF: { amount: 100, type: "percentage" },
      C04VF: { amount: 100, type: "percentage" },
      C04DF: { amount: 100, type: "percentage" },
      C05BM: { amount: 100, type: "percentage" },
      C06BM: { amount: 100, type: "percentage" },
      C06CM: { amount: 100, type: "percentage" },
      C08BM: { amount: 100, type: "percentage" },
      C09BM: { amount: 100, type: "percentage" },
    },
  },
];
